import { render, staticRenderFns } from "./fault.vue?vue&type=template&id=5454f6d4&scoped=true&"
import script from "./fault.vue?vue&type=script&lang=js&"
export * from "./fault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454f6d4",
  null
  
)

export default component.exports